import { map } from 'lodash';
import { BaseModel } from './BaseModel';
import Learner from './Learner';
import Status from './Status';
import Section from './Section';
import Post from './Post';
import UserEnrollment from './UserEnrollment';

export class AssessmentStatus extends BaseModel {
  static get entity() {
    return 'assessment-statuses';
  }

  static get fk() {
    return 'assessment_status_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null),
      review_pending_at: this.attr(null),
      count_change_to_review_pending: this.number(0),
      status_id: this.attr(null),
      status: this.belongsTo(Status, 'status_id'),
      user_id: this.attr(null),
      user: this.belongsTo(Learner, 'user_id'),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id')
    };
  }

  static countStatusInPostInSection(statusId, postId, sectionId) {
    let count = 0;

    const section = Section.find(sectionId);

    if (section?.user_enrollments_ids?.length) {
      const userEnrollments = UserEnrollment.findIn(section.user_enrollments_ids);

      if (userEnrollments?.length) {
        const learnerUids = map(userEnrollments, 'uid');
        const learners = learnerUids
          .map((uid) => Learner.query().where('uid', uid).first())
          .filter(Boolean);

        if (learners?.length) {
          const learnerIds = map(learners, 'id');

          count = AssessmentStatus.query()
            .where('post_id', postId)
            .where('status_id', statusId)
            .where('user_id', (value) => {
              return learnerIds.includes(value);
            })
            .count();
        }
      }
    }

    return count;
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get(`/assessment-statuses`);
      },

      fetchByAssessmentStatusId(assessment_status_id) {
        return this.get(`/assessment-statuses/${assessment_status_id}`);
      },

      fetchByUserId(user_id) {
        return this.get(`/assessment-statuses?user=${user_id}`);
      },

      fetchByPostId(post_id) {
        return this.get(`/assessment-statuses?post=${post_id}`);
      },

      fetchPostStatus(userId, postId) {
        return this.get(`/assessment-statuses?post=${postId}&user=${userId}`);
      }
    }
  };
}

export default AssessmentStatus;
